const GitCommit = [
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": 2,
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  },
  [
    ["circle", { cx: "12", cy: "12", r: "3" }],
    ["line", { x1: "3", y1: "12", x2: "9", y2: "12" }],
    ["line", { x1: "15", y1: "12", x2: "21", y2: "12" }]
  ]
];

export default GitCommit;
